module.exports = "https://www.gc-qa.gnp.com.mx/4c6ef193ef7ff68e3b6c7b481959a31a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_add_naranja.png
// module id = 8132
// module chunks = 0